import {checkAndUpdateToken} from "./auth";
import {
    GRANTS_YEARS,
    CANDIDATS_LIST,
    SET_CANDIDATS_LIST_LOADING,
    GRANTS_TERMS,
    GRANTS_OPTIONS,
    SET_GRANTS_OPTIONS_LOADING,
    CANDIDATS_LIST_FILE,
    SET_CANDIDATS_LIST_FILE_LOADING,
    GRANTS_CHIEFS,
    SET_CANDIDAT_INFO,
    SET_CANDIDAT_INFO_LOADING,
    GRANTS_TASK,
    SET_EXCEL_LIST,
    SET_EXCEL_LIST_LOADING,
    SET_GRANT_TYPES,
    SET_GRANT_TYPES_LOADING,
    SET_SCHOLARSHIP_SETTINGS,
    SET_SCHOLARSHIP_SETTINGS_LOADING,
    SET_SCHOLARSHIP_LEVELS,
    SET_SCHOLARSHIP_LEVELS_LOADING,
    SET_SCHOLARSHIP_TREE,
    SET_SCHOLARSHIP_TREE_LOADING,
    SET_SCHOLARSHIP_GRANTS_LIST,
    SET_SCHOLARSHIP_GRANTS_LIST_LOADING
} from "./types";
import {BACKEND_URL_PREFIX} from "../utils/const";
import {buildDefaultHeaders} from "./helper";
import {createNotification} from "../components/notifications/notifications";
import { saveAs } from 'file-saver'; // Библиотека для сохранения файлов

import timer from 'timers-promises'

export const getGrantsYears = () => async(dispatch, getState) => {
    await dispatch(checkAndUpdateToken());
    if (getState().auth.token) {
        const response = await fetch(`${BACKEND_URL_PREFIX}/year/scy`, buildDefaultHeaders(getState));

        dispatch({type: GRANTS_YEARS, response});

        if (response.ok) {
            const result = await response.json();
            dispatch({type: GRANTS_YEARS, payload: result.schoolYear});
        }
    }
};

export const getGrantsTerms = (type, date) => async(dispatch, getState) => {
    await dispatch(checkAndUpdateToken());
    if (getState().auth.token) {
        const response = await fetch(`${BACKEND_URL_PREFIX}/terms?date=${date.date_to}`, buildDefaultHeaders(getState));

        if (response.ok) {
            const result = await response.json();
            dispatch({type: GRANTS_TERMS, payload: {type: type, date: result}});
        }
    }
};

export const getCandidats = (yearID) => async(dispatch, getState) => {
    await dispatch(checkAndUpdateToken());
    if (getState().auth.token) {
        dispatch({type: SET_CANDIDATS_LIST_LOADING, payload: true});
        try {
            const response = await fetch(`${BACKEND_URL_PREFIX}/degree_candidates/${yearID}`, buildDefaultHeaders(getState));
            const result = await response.json();
            if (response.status === 202) {
                dispatch(getStatus(result.task_id));
                dispatch({type: GRANTS_TASK, payload: result.task_id});
            } else {
                createNotification('error', result.error)
            }
        } catch (ERR) {} finally {}
    }
};

export const getStatus = (hash) => async (dispatch, getState) => {
  try {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/degree_candidates_task/${hash}`,
      {
        method: "GET",
        ...buildDefaultHeaders(getState),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    if (data.status === 'in_progress') {
      await timer.setTimeout(5000);
      return await dispatch(getStatus(hash));
    } else if (data.status === 'failed') {
      createNotification('error', 'Ошибка');
      dispatch({ type: SET_CANDIDATS_LIST_LOADING, payload: false });
      return [];
    } else {
      if (data.status === 'completed') {
        createNotification('success', 'Список сформирован');
      }
      dispatch({ type: CANDIDATS_LIST, payload: data.data });
      dispatch({ type: SET_CANDIDATS_LIST_LOADING, payload: false });
      return data.data || [];
    }
  } catch (error) {
    console.error('Error in getStatus:', error);
    createNotification('error', 'Ошибка');
    dispatch({ type: SET_CANDIDATS_LIST_LOADING, payload: false });
    return [];
  }
};

export const getCandidatsTrash = () => async(dispatch, getState) => {
    await dispatch(checkAndUpdateToken());
    if (getState().auth.token) {
        dispatch({type: CANDIDATS_LIST, payload: null});
    }
};

export const getGrantsOptions = (yearID) => async(dispatch, getState) => {
    await dispatch(checkAndUpdateToken());
    dispatch({type: SET_GRANTS_OPTIONS_LOADING, payload: true});
    if (getState().auth.token) {
        try {
            const response = await fetch(`${BACKEND_URL_PREFIX}/scholarship_list_options?xp_key=${yearID}`, buildDefaultHeaders(getState));

            dispatch({type: GRANTS_OPTIONS, response});

            if (response.ok) {
                const result = await response.json();
                dispatch({type: GRANTS_OPTIONS, payload: result});
            }
        } catch (error) {} finally {
            dispatch({type: SET_GRANTS_OPTIONS_LOADING, payload: false});
        }
    }
};

export const editGrantsOptions = (data, yearId) => async(dispatch, getState) => {
    await dispatch(checkAndUpdateToken());

    const newData = data.map(el => (
        {...el, 
            trmids: el.trmids.map(el => Number(el.trmid))
        }))
            .filter(el => el.trmids.length > 0)
            .map(el => ({
                xp_key: Number(yearId),
                trmids: el.trmids,
                date_to: el.date_to,
                date_from: el.date_from,
                education_level: el.education_level,
                prep_struc_category_id: el.prep_struc_category_id
            }))
            ;

    if (!getState().auth.token) 
        return;
    try {
        const response = await fetch(`${BACKEND_URL_PREFIX}/scholarship_list_options`, {
            ...buildDefaultHeaders(getState),
            method: "POST",
            body: JSON.stringify(newData)
        });

        if (response.ok) {
            dispatch(getCandidats(yearId))
        }
    } catch (ERR) {} finally {}
};

export const setGrantsType = (data) => async(dispatch, getState) => {

    await dispatch(checkAndUpdateToken());
    if (!getState().auth.token) 
        return;
    try {

        const response = await fetch(`${BACKEND_URL_PREFIX}/scholarship_candidates`, {
            ...buildDefaultHeaders(getState),
            method: "POST",
            body: JSON.stringify(data)
        });

        if (response.ok) {
            createNotification('success', 'Успешно')
        }
    } catch (ERR) {
        createNotification('error', 'Ошибка')
        dispatch(getCandidats(data.xp_key))
    } finally {}
};

export const getCandidatsForFile = (type, yearID, taskId) => async(dispatch, getState) => {
    await dispatch(checkAndUpdateToken());
    if (getState().auth.token) {
        dispatch({type: SET_CANDIDATS_LIST_FILE_LOADING, payload: true});
        try {
            const response = await fetch(`${BACKEND_URL_PREFIX}/scholarship_candidates/${type}/${taskId}/${yearID}`, buildDefaultHeaders(getState));

            if (response.ok) {
                const result = await response.json();
                const isLength = Object.values(result);
                
                if (isLength.flat().length === 0) {
                    createNotification('error', 'Нет данных');
                } else {
                    dispatch({
                        type: CANDIDATS_LIST_FILE,
                        payload: {
                            type: type,
                            result: result
                        }
                    });
                }
            }
        } catch (ERR) {} finally {
            dispatch({type: SET_CANDIDATS_LIST_FILE_LOADING, payload: false});
        }
    }
};

export const getCandidatsForExcel = (type, yearID, taskId, title) => async (dispatch, getState) => {

    await dispatch(checkAndUpdateToken()); // Проверка и обновление токена

    if (getState().auth.token) {
        // Устанавливаем статус загрузки
        dispatch({ type: SET_CANDIDATS_LIST_FILE_LOADING, payload: true });

        try {
            // Отправляем запрос на сервер для получения файла
            const response = await fetch(
                `${BACKEND_URL_PREFIX}/scholarship_candidates/excel/${type}/${taskId}/${yearID}`,
                buildDefaultHeaders(getState)
            );

            // Проверяем, успешен ли запрос
            if (response.status === 200) {
                // Получаем имя файла из заголовков ответа (если оно указано)
                const contentDisposition = response.headers.get('Content-Disposition');
                // const fileName = contentDisposition
                //     ? contentDisposition.split('filename=')[1].replace(/['"]/g, '') // Извлекаем имя файла
                //     : `${title}.xlsx`; // По умолчанию называем файл

                // Получаем blob-данные файла
                const blob = await response.blob();

                // Сохраняем файл на клиенте
                saveAs(blob, title);

                // console.log('Файл успешно скачан:', fileName);
                createNotification('success', `Успешно скачан: ${title} `)
            } else {
                // Если запрос не успешен, выводим сообщение об ошибке
                createNotification('error', `Ошибка: нет данных`)
                // console.error('Ошибка при получении файла:', response.statusText);
            }
        } catch (ERR) {
            // Обработка ошибок
            createNotification('error', `Произошла ошибка: ${ERR.message || ERR}`)
            // console.error('Произошла ошибка:', ERR.message || ERR);
        } finally {
            // Снимаем статус загрузки
            dispatch({ type: SET_CANDIDATS_LIST_FILE_LOADING, payload: false });
        }
    } else {
        // console.error('Токен авторизации отсутствует.');
    }
};

export const getCandidatsForFileTrash = (type) => async(dispatch, getState) => {
    await dispatch(checkAndUpdateToken());
    if (getState().auth.token) {
        dispatch({
            type: CANDIDATS_LIST_FILE,
            payload: {
                type: type,
                result: null
            }
        });
    }
};

export const getChiefs = () => async(dispatch, getState) => {
    await dispatch(checkAndUpdateToken());
    if (getState().auth.token) {
        const response = await fetch(`${BACKEND_URL_PREFIX}/chiefs`, buildDefaultHeaders(getState));

        if (response.ok) {
            const result = await response.json();
            dispatch({type: GRANTS_CHIEFS, payload: result.chiefs[0]});
        }
    }
};


export const getInfoForStudent = (mid, gid, xp_key, education_level, prep_struc_category_id) => async(dispatch, getState) => {
    await dispatch(checkAndUpdateToken());
    if (getState().auth.token) {
        dispatch({type: SET_CANDIDAT_INFO_LOADING, payload: true});

        try {
            const response = await fetch(`${BACKEND_URL_PREFIX}/degree_candidates/info/${mid}/${gid}/${xp_key}/${education_level}/${prep_struc_category_id}`, buildDefaultHeaders(getState));

            if (response.ok) {
                const result = await response.json();
                if (result === false) return createNotification('error', 'Нет данных')
                    
                dispatch({
                    type: SET_CANDIDAT_INFO,
                    payload: result
                });
            } else {
                const result = await response.json();
                createNotification('error', result.error)
            }
        } catch (ERR) {} finally {
            dispatch({type: SET_CANDIDAT_INFO_LOADING, payload: false});
        }
    }
};

export const getCandidatInfoTrash = () => async(dispatch, getState) => {
    await dispatch(checkAndUpdateToken());
    if (getState().auth.token) {
        dispatch({type: SET_CANDIDAT_INFO, payload: null});
    }
};


// EXCEL

export const getExcelList = (mid) => async(dispatch, getState) => {
    dispatch({type: SET_EXCEL_LIST_LOADING, payload: true});
    await dispatch(checkAndUpdateToken());
    if (getState().auth.token) {
        const response = await fetch(`${BACKEND_URL_PREFIX}/scholarship_candidates/files_storage/${mid}`, buildDefaultHeaders(getState));
        
        if (response.ok) {
            const result = await response.json();
            dispatch({type: SET_EXCEL_LIST, payload: result});
        }
    }
    dispatch({type: SET_EXCEL_LIST_LOADING, payload: false});
};

export const uploadExcelFile = (file, chapter, mid) => async (
  dispatch,
  getState
) => {

  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const { token } = getState().auth;
    const formData = new FormData();
    formData.append('files', file);
    formData.append('chapter', chapter);
    formData.append('mid', mid);
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/scholarship_candidates/files_storage`,
      {
        method: "POST",
        body: formData,
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Basic ${btoa(`${token}:empty`)}`,
        },
      }
    );

    if (response.ok) {
      dispatch(getExcelList(mid));
    } else {
      const result = await response.json();
      createNotification('error', result.error);
    }
  }
};

export const deleteExcelFile = (mid, chapter, file_name) => async (
  dispatch,
  getState
) => {
  const { token } = getState().auth;
  const response = await fetch(
    `${BACKEND_URL_PREFIX}/scholarship_candidates/files_storage/${mid}/${chapter}/${file_name}`,
    {
      method: "DELETE",
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: `Basic ${btoa(`${token}:empty`)}`,
      },
    }
  );

  if (response.ok) {
    dispatch(getExcelList(mid));
  }
};

export const downloadExcelFile = (mid, chapter, file_name) => async(dispatch, getState) => {
    dispatch({type: SET_EXCEL_LIST_LOADING, payload: true});
    await dispatch(checkAndUpdateToken());
    if (getState().auth.token) {
        try {
            const response = await fetch(`${BACKEND_URL_PREFIX}/scholarship_candidates/files_storage/${mid}/${chapter}/${file_name}`, buildDefaultHeaders(getState));
            
            if (response.ok) {
                const blob = await response.blob();
                
                // Создаем ссылку для скачивания файла
                const url = URL.createObjectURL(blob);
                
                // Создаем атрибуты для скачки
                const a = document.createElement('a');
                a.href = url;
                a.download = file_name;
                a.click();
                
                // Удаляем созданную ссылку
                URL.revokeObjectURL(url);
            }
        } catch (error) {
            console.error(error);
        }
    }
    dispatch({type: SET_EXCEL_LIST_LOADING, payload: false});
};

// EXCEL


export const getGrantTypes = () => async(dispatch, getState) => {
    await dispatch(checkAndUpdateToken());
    if (getState().auth.token) {
        dispatch({type: SET_GRANT_TYPES_LOADING, payload: true});

        try {
            const response = await fetch(`${BACKEND_URL_PREFIX}/scholarship_types`, buildDefaultHeaders(getState));

            if (response.ok) {
                const result = await response.json();
                if (result === false) return createNotification('error', 'Нет данных')
                    
                dispatch({
                    type: SET_GRANT_TYPES,
                    payload: result
                });
            } else {
                const result = await response.json();
                createNotification('error', result.error)
            }
        } catch (ERR) {} finally {
            dispatch({type: SET_GRANT_TYPES_LOADING, payload: false});
        }
    }
};

export const createGrantType = (data) => async(dispatch, getState) => {
    dispatch({type: SET_GRANT_TYPES_LOADING, payload: true});
    await dispatch(checkAndUpdateToken());
    if (!getState().auth.token) 
        return;
    try {

        const response = await fetch(`${BACKEND_URL_PREFIX}/scholarship_types`, {
            ...buildDefaultHeaders(getState),
            method: "POST",
            body: JSON.stringify(data)
        });

        if (response.ok) {
            createNotification('success', 'Успешно')
        }
    } catch (ERR) {
        createNotification('error', 'Ошибка')
    } finally {
        dispatch({type: SET_GRANT_TYPES_LOADING, payload: false});
        dispatch(getGrantTypes());
    }
};

export const editGrantType = (data) => async(dispatch, getState) => {
    dispatch({type: SET_GRANT_TYPES_LOADING, payload: true});
    await dispatch(checkAndUpdateToken());
    if (!getState().auth.token) 
        return;
    try {

        const response = await fetch(`${BACKEND_URL_PREFIX}/scholarship_types`, {
            ...buildDefaultHeaders(getState),
            method: "PUT",
            body: JSON.stringify(data)
        });

        if (response.ok) {
            createNotification('success', 'Успешно')
        }
    } catch (ERR) {
        createNotification('error', 'Ошибка')
    } finally {
        dispatch({type: SET_GRANT_TYPES_LOADING, payload: false});
        dispatch(getGrantTypes());
    }
};

export const removeGrantTypes = (id) => async(dispatch, getState) => {
    await dispatch(checkAndUpdateToken());
    if (getState().auth.token) {
        dispatch({type: SET_GRANT_TYPES_LOADING, payload: true});

        try {
            const response = await fetch(`${BACKEND_URL_PREFIX}/scholarship_types/${id}`, {
                ...buildDefaultHeaders(getState),
                method: "DELETE"
            });

            if (response.ok) {
            createNotification('success', 'Успешно');
            // dispatch(getCandidats(yearId))
            } else {
                const result = await response.json();
                createNotification('error', `Ошибка: ${result.error}`)
            }
        } catch (ERR) {} finally {
            dispatch({type: SET_GRANT_TYPES_LOADING, payload: false});
            dispatch(getGrantTypes());
        }
    }
};

export const getScholarshipSettings = (year, scholarship_type_id) => async(dispatch, getState) => {
    await dispatch(checkAndUpdateToken());
    if (getState().auth.token) {
        dispatch({type: SET_SCHOLARSHIP_SETTINGS_LOADING, payload: true});

        try {
            const response = await fetch(`${BACKEND_URL_PREFIX}/scholarship_settings?xp_key=${year}&scholarship_type_id=${scholarship_type_id}`, buildDefaultHeaders(getState));

            if (response.ok) {
                const result = await response.json();
                if (result === false) return createNotification('error', 'Нет данных')
                    
                dispatch({
                    type: SET_SCHOLARSHIP_SETTINGS,
                    payload: result
                });
            } else {
                const result = await response.json();
                createNotification('error', result.error)
            }
        } catch (ERR) {} finally {
            dispatch({type: SET_SCHOLARSHIP_SETTINGS_LOADING, payload: false});
        }
    }
};

export const getScholarshipLevels = () => async(dispatch, getState) => {
    await dispatch(checkAndUpdateToken());
    if (getState().auth.token) {
        dispatch({type: SET_SCHOLARSHIP_LEVELS_LOADING, payload: true});

        try {
            const response = await fetch(`${BACKEND_URL_PREFIX}/scholarship_settings/education_levels`, buildDefaultHeaders(getState));

            if (response.ok) {
                const result = await response.json();
                if (result === false) return createNotification('error', 'Нет данных')
                    
                dispatch({
                    type: SET_SCHOLARSHIP_LEVELS,
                    payload: result
                });
            } else {
                const result = await response.json();
                createNotification('error', result.error)
            }
        } catch (ERR) {} finally {
            dispatch({type: SET_SCHOLARSHIP_LEVELS_LOADING, payload: false});
        }
    }
};

export const addScholarshipSettings = (data, yearId, scholarship_type_id) => async(dispatch, getState) => {
    await dispatch(checkAndUpdateToken());
    let newData = data.map(el => (
        {...el, 
            trmids: el.trmids.map(el => Number(el.trmid)),
            xp_key: Number(yearId),
            scholarship_type_id: Number(scholarship_type_id)
        }));
    
        newData.map(el => {
            if (typeof el?.id === 'string' && el?.id?.startsWith('id-')) delete el.id;
            delete el.prep_struc_category
            return el;
        })


    if (!getState().auth.token) 
        return;
    try {
        const response = await fetch(`${BACKEND_URL_PREFIX}/scholarship_settings`, {
            ...buildDefaultHeaders(getState),
            method: "POST",
            body: JSON.stringify(newData)
        });

        if (response.ok) {
            createNotification('success', 'Успешно');
            // dispatch(getCandidats(yearId))
        } else {
            const result = await response.json();
            createNotification('error', `Ошибка: ${result.error}`)
        }
    } catch (ERR) {} finally {}
};

export const editScholarshipSettings = (data, yearId, scholarship_type_id) => async(dispatch, getState) => {
    await dispatch(checkAndUpdateToken());
    let newData = data.map(el => (
        {...el, 
            trmids: el.trmids.map(el => Number(el.trmid)),
            xp_key: Number(yearId),
            scholarship_type_id: Number(scholarship_type_id)
        }));
    
        newData.map(el => {
            delete el.prep_struc_category
            return el;
        })


    if (!getState().auth.token) 
        return;
    try {
        const response = await fetch(`${BACKEND_URL_PREFIX}/scholarship_settings`, {
            ...buildDefaultHeaders(getState),
            method: "PUT",
            body: JSON.stringify(newData)
        });

        if (response.ok) {
            createNotification('success', 'Успешно');
            // dispatch(getCandidats(yearId))
        } else {
            const result = await response.json();
            createNotification('error', `Ошибка: ${result.error}`)
        }
    } catch (ERR) {} finally {}
};

// 👉 вставь это выше внутри файла actions (или вынеси в utils)
const sortScholarshipTree = (nodes, depth = 0) => {
  if (!Array.isArray(nodes)) return [];

  return [...nodes]
    .sort((a, b) => {
      const isLeaf = (node) =>
        (!node.child || node.child.length === 0) &&
        (typeof node.link_ordering !== "undefined");

      const getSortKey = (node) => {
        if (depth >= 2 && isLeaf(node)) {
          // Листовой уровень (достижения) — сортируем по link_ordering
          return node.link_ordering || 0;
        }
        // Ветки — по ordering
        return node.ordering || 0;
      };

      return getSortKey(a) - getSortKey(b);
    })
    .map((node) => ({
      ...node,
      child: sortScholarshipTree(node.child || [], depth + 1),
    }));
};



export const getScholarshipTree = (xp_key) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: SET_SCHOLARSHIP_TREE_LOADING, payload: true });

    try {
      const response = await fetch(
        `${BACKEND_URL_PREFIX}/scholarship_tree?xp_key=${xp_key}`,
        buildDefaultHeaders(getState)
      );

      if (response.ok) {
        const result = await response.json();

        // 🔁 Сортируем дерево перед сохранением в стор
        const sorted = sortScholarshipTree(result);

        dispatch({
          type: SET_SCHOLARSHIP_TREE,
          payload: sorted,
        });
      } else {
        const result = await response.json();
        createNotification('error', result.error);
      }
    } catch (ERR) {
      // логировать можно здесь
    } finally {
      dispatch({ type: SET_SCHOLARSHIP_TREE_LOADING, payload: false });
    }
  }
};


export const getListGrants = (xp_key) => async(dispatch, getState) => {
    await dispatch(checkAndUpdateToken());
    if (getState().auth.token) {
        dispatch({type: SET_SCHOLARSHIP_GRANTS_LIST_LOADING, payload: true});

        try {
            const response = await fetch(`${BACKEND_URL_PREFIX}/scholarship_tree/list_grants`, buildDefaultHeaders(getState));

            if (response.ok) {
                const result = await response.json();
                if (result === false) return createNotification('error', 'Нет данных')
                let newData = result.map(el => ({
                    id: el.indicator_id,
                    title: el.indicator_title,
                    xp_key: xp_key    
                }))
                dispatch({
                    type: SET_SCHOLARSHIP_GRANTS_LIST,
                    payload: newData
                });
            } else {
                const result = await response.json();
                createNotification('error', result.error)
            }
        } catch (ERR) {} finally {
            dispatch({type: SET_SCHOLARSHIP_GRANTS_LIST_LOADING, payload: false});
        }
    }
};

export const addNewTree = (data) => async(dispatch, getState) => {
    await dispatch(checkAndUpdateToken());

    if (!getState().auth.token) 
        return;
    try {
        const response = await fetch(`${BACKEND_URL_PREFIX}/scholarship_tree`, {
            ...buildDefaultHeaders(getState),
            method: "POST",
            body: JSON.stringify({...data, xp_key: Number(data.xp_key), parent_id: Number(data.parent_id) || 0})
        });

        if (response.ok) {

        } else {
            const result = await response.json();
            createNotification('error', result.error)
        }
    } catch (ERR) {} finally {
        dispatch(getScholarshipTree(data.xp_key));
    }
};

export const addScholarshipTree = (id, data, yearId) => async(dispatch, getState) => {

    await dispatch(checkAndUpdateToken());
    if (!getState().auth.token) 
        return;
    try {
        const response = await fetch(`${BACKEND_URL_PREFIX}/scholarship_tree/${Number(id)}`, {
            ...buildDefaultHeaders(getState),
            method: "PUT",
            body: JSON.stringify({...data, xp_key: Number(data.xp_key),
                personnel_indicator_ids: data.personnel_indicator_ids.map(el => ({
                    personnel_indicator_id: el.personnel_indicator_id,
                    ordering: el.ordering
                }))
            })
        });

        if (response.ok) {

        } else {
            const result = await response.json();
            createNotification('error', result.error)
        }
    } catch (ERR) {} finally {
        dispatch(getScholarshipTree(yearId));
    }
};

export const removeScholarshipTree = (id, yearId) => async(dispatch, getState) => {

    await dispatch(checkAndUpdateToken());
    if (getState().auth.token) {
        dispatch({type: SET_SCHOLARSHIP_GRANTS_LIST_LOADING, payload: true});

        try {
            const response = await fetch(`${BACKEND_URL_PREFIX}/scholarship_tree/${id}?approve=true`, {
                ...buildDefaultHeaders(getState),
                method: "DELETE"
            });

            const result = await response.json();
            if (response.ok) {
            createNotification('success', result.message);
            // dispatch(getCandidats(yearId))
            } else {
                createNotification('error', `Ошибка: ${result.error}`)
            }
        } catch (ERR) {} finally {
            dispatch({type: SET_SCHOLARSHIP_GRANTS_LIST_LOADING, payload: false});
            dispatch(getScholarshipTree(yearId));
        }
    }
};